/** One "when was this sent" timestamp format for every notification surface:
 *  `2026-10-08 21:45:00` (the ISO-like `YYYY-MM-DD HH:MM:SS` the alarm warnings
 *  use; `toLocaleString("sv-SE")` is what produces that shape). null for a
 *  missing or unparseable stamp — render nothing then, never a guess. */
export function formatSentAt(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const at = new Date(iso);
  return Number.isNaN(at.getTime()) ? null : at.toLocaleString("sv-SE");
}

/** The dimmed timestamp line shared by the portal surfaces (below the card's
 *  text; the caller picks the size). */
export function sentAtNote(iso: string | null | undefined): string | null {
  const at = formatSentAt(iso);
  return at ? `Sent ${at}` : null;
}
